var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInConsegnaBlu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 61 55",
    style: {
      enableBackground: "new 0 0 61 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M10.7,54.7c-0.2,0-0.5-0.1-0.6-0.2c-0.4-0.3-9.5-8.1-10-16.8c-0.2-2.8,0.7-5.4,2.6-7.3c2-2.2,5-3.4,8.1-3.4 s6.1,1.2,8.1,3.4c1.8,2,2.8,4.6,2.6,7.3c-0.6,8.7-9.7,16.4-10,16.8C11.1,54.7,10.9,54.7,10.7,54.7z M10.7,29c-2.6,0-5.1,1-6.7,2.8 c-1.5,1.6-2.2,3.6-2,5.9c0.5,6.6,6.7,13,8.7,14.9c2-1.9,8.3-8.2,8.7-14.9c0.2-2.3-0.6-4.3-2-5.9C15.7,30,13.3,29,10.7,29z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M10.7,42.4c-2.8,0-5.1-2.3-5.1-5.1s2.3-5.1,5.1-5.1s5.1,2.3,5.1,5.1C15.8,40.1,13.5,42.4,10.7,42.4z  M10.7,34.2c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1S12.4,34.2,10.7,34.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M47,16.4c-0.2,0-0.5-0.1-0.6-0.2c-0.2-0.2-5.4-4.6-5.8-9.7c-0.1-1.7,0.4-3.2,1.6-4.4c1.2-1.3,3-2,4.9-2 s3.7,0.7,4.9,2c1.1,1.2,1.7,2.8,1.6,4.4c-0.3,5.1-5.6,9.5-5.8,9.7C47.5,16.3,47.3,16.4,47,16.4z M47,1.9c-1.3,0-2.6,0.5-3.5,1.4 c-0.8,0.8-1.1,1.8-1,3c0.2,3.3,3.2,6.5,4.5,7.8c1.3-1.3,4.3-4.5,4.5-7.8c0.1-1.1-0.3-2.2-1-3C49.6,2.5,48.4,1.9,47,1.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M47,9.5c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3S48.8,9.5,47,9.5z M47,4.9 c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3C48.4,5.5,47.8,4.9,47,4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M37.5,54.1H18.1c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1h19.5c4.8,0,5.8-3.5,6-5c0-0.1,0-0.2,0-0.4 c-0.1-2.9-2.7-5.2-6.1-5.4c-1.4-0.1-2.7,0-2.7,0h-4.6c-2.8,0-5.1-2.1-5.1-4.7c0-2.6,2.3-4.7,5.1-4.7c0.5,0,1,0.4,1,1 c0,0.5-0.4,1-1,1c-1.8,0-3.2,1.2-3.2,2.7s1.4,2.7,3.2,2.7h4.6c0,0,1.4-0.1,2.9,0c4.3,0.3,7.7,3.4,7.8,7.3c0,0.2,0,0.5,0,0.7 C45,50.7,42.7,54.1,37.5,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M46.7,38.6c-0.1,0-0.2,0-0.4-0.1l-12.8-5.3c-0.4-0.1-0.6-0.5-0.6-0.9V17c0-0.3,0.2-0.6,0.4-0.8 c0.3-0.2,0.6-0.2,0.9-0.1L47,21.4c0.4,0.1,0.6,0.5,0.6,0.9v15.3c0,0.3-0.2,0.6-0.4,0.8C47.1,38.5,46.9,38.6,46.7,38.6z M34.9,31.7 l10.8,4.5V22.9l-10.8-4.5V31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M46.8,38.6c-0.4,0-0.7-0.2-0.9-0.6c-0.2-0.5,0-1.1,0.5-1.3l12.2-5V18.5l-11.4,4.7c-0.5,0.2-1.1,0-1.3-0.5 s0-1.1,0.5-1.3l12.8-5.3c0.3-0.1,0.6-0.1,0.9,0.1c0.3,0.2,0.4,0.5,0.4,0.8v15.3c0,0.4-0.2,0.7-0.6,0.9l-12.8,5.3 C47,38.6,46.9,38.6,46.8,38.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M59.5,17.9c-0.1,0-0.2,0-0.4-0.1l-6.6-2.7c-0.5-0.2-0.7-0.8-0.5-1.3s0.8-0.7,1.3-0.5l6.6,2.7 c0.5,0.2,0.7,0.8,0.5,1.3C60.3,17.7,59.9,17.9,59.5,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M34,17.9c-0.4,0-0.7-0.2-0.9-0.6c-0.2-0.5,0-1.1,0.5-1.3l7.4-3c0.5-0.2,1.1,0,1.3,0.5s0,1.1-0.5,1.3l-7.4,3.1 C34.2,17.9,34.1,17.9,34,17.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInConsegnaBlu);
export default __webpack_public_path__ + "static/media/inConsegnaBlu.d2890d82.svg";
export { ForwardRef as ReactComponent };